if (!customElements.get("nmn-product-community")) {
  customElements.define(
    "nmn-product-community",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.querySelectorAll("[data-community-clone]").forEach((card) => card.remove());
        this.controller = new AbortController();
        this.track = this.querySelector("[data-community-track]");
        this.cards = Array.from(this.querySelectorAll("[data-community-card]"));
        if (!this.track || !this.cards.length) return;

        // Extra cards at either end keep both mobile hints visible and allow wrapping.
        this.cloneCount = Math.min(6, this.cards.length);
        const cloneCard = (card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute("data-community-clone", "");
          clone.setAttribute("aria-hidden", "true");
          clone.inert = true;
          return clone;
        };
        this.track.prepend(...this.cards.slice(-this.cloneCount).map(cloneCard));
        this.track.append(...this.cards.slice(0, this.cloneCount).map(cloneCard));
        this.slides = Array.from(this.track.children);
        this.activeIndex = 0;
        const options = { signal: this.controller.signal };

        this.querySelectorAll("[data-community-direction]").forEach((button) => {
          button.addEventListener("click", () => this.navigate(Number(button.dataset.communityDirection)), options);
          button.hidden = this.cards.length <= this.pageSize;
        });
        this.track.addEventListener("keydown", (event) => {
          if (event.target !== this.track) return;
          if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
          event.preventDefault();
          this.navigate(event.key === "ArrowLeft" ? -1 : 1);
        }, options);
        this.track.addEventListener("scroll", () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.settle(), 150);
        }, { ...options, passive: true });
        this.observer = new ResizeObserver(() => {
          this.scrollToSlide(this.cloneCount + this.activeIndex, "instant");
          this.querySelectorAll("[data-community-direction]").forEach((button) => {
            button.hidden = this.cards.length <= this.pageSize;
          });
        });
        this.observer.observe(this.track);
        this.scrollToSlide(this.cloneCount, "instant");
      }

      get pageSize() {
        return window.matchMedia("(max-width: 749px)").matches ? 1 : 3;
      }

      slideOffset(slide) {
        const inset = parseFloat(getComputedStyle(this.track).paddingLeft);
        return slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - inset;
      }

      nearestSlide() {
        return this.slides.reduce((nearest, slide, index) => {
          return Math.abs(this.slideOffset(slide) - this.track.scrollLeft) <
            Math.abs(this.slideOffset(this.slides[nearest]) - this.track.scrollLeft) ? index : nearest;
        }, 0);
      }

      scrollToSlide(index, behavior) {
        const slide = this.slides[index];
        if (!slide) return;
        this.track.scrollTo({ left: this.slideOffset(slide), behavior });
      }

      navigate(direction) {
        this.settle();
        const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth";
        this.scrollToSlide(this.cloneCount + this.activeIndex + direction * this.pageSize, behavior);
      }

      settle() {
        const nearest = this.nearestSlide();
        this.activeIndex = ((nearest - this.cloneCount) % this.cards.length + this.cards.length) % this.cards.length;
        if (nearest < this.cloneCount || nearest >= this.cloneCount + this.cards.length) {
          this.scrollToSlide(this.cloneCount + this.activeIndex, "instant");
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.scrollTimer);
      }
    },
  );
}
